import firebase from 'firebase'
import 'firebase/auth'

var config = {
    apiKey: "AIzaSyAXVvFRV-2Be-mgafc0_p8hbBIzZSHfmjU",
    authDomain: "autom8d-63203.firebaseapp.com",
    projectId: "autom8d-63203",
    storageBucket: "autom8d-63203.appspot.com",
    messagingSenderId: "784255856380",
    appId: "1:784255856380:web:c60187decdf4b6343a3179",
    measurementId: "G-2S1J42V15K"
}

const fire = firebase.initializeApp(config)
export const auth = fire.auth()
export const provider = new firebase.auth.GoogleAuthProvider()
export default fire;